import { Button, Col, Container, Row } from "react-bootstrap";
import { Dialog } from "primereact/dialog";

import "./index.scss";

export default function ForceWarningPopUp({ visible, onNo, onYes }) {
  return (
    <>
      <Dialog
        header="You are about to Force Approve this job. Any markups will be ignored, Complete-Rejected tasks will change to Complete-Approved, and Awaiting and In-Progress tasks will change to Complete-Approved. Are you sure you want to proceed?"
        visible={visible}
        onHide={onNo}
        className="force-warning-popup"
      >
        <Container>
          <Row className="mt-4">
            <div className="d-flex justify-content-end">
              <Button type="btn" className="btn btn-secondary me-3" onClick={onNo}>
                No
              </Button>
              <Button type="btn" className="btn btn-primary" onClick={onYes}>
                Yes
              </Button>
            </div>
          </Row>
        </Container>
      </Dialog>
    </>
  );
}
